import React from 'react'
import {Link} from 'react-router-dom'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {faHouseChimney} from '@fortawesome/free-solid-svg-icons'

class BreadcrumbSector extends React.Component {
    render() {
        return(
            <div className="breadcrumbs">
                <div className="container">
                    <ul>
                        <li><Link to="/"><FontAwesomeIcon icon={faHouseChimney} /></Link></li>
                        <li><Link to="/sectors">Sectors</Link></li>
                        <li><span>{this.props.title}</span></li>
                    </ul>
                </div>
            </div>
        )
    }
}

export default BreadcrumbSector